import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { fetchBrokerLinkData, saveAgreementAccepted } from '../../../services';
import { NewbuildingBrokerContext } from '../../../shared/context';
import { FETCH_URL_TIMEOUT, FETCH_URL_TIMEOUT_RESULT } from '../../../constants/timeout';
export var useBrokerLinkFetcher = function useBrokerLinkFetcher(_ref) {
  var newbuildingId = _ref.newbuildingId,
    newbuildingRegionId = _ref.newbuildingRegionId,
    houseId = _ref.houseId,
    openFetchingModal = _ref.openFetchingModal,
    closeFetchingModal = _ref.closeFetchingModal,
    openErrorModal = _ref.openErrorModal,
    openAlreadyRegisteredModal = _ref.openAlreadyRegisteredModal,
    onErrorModalOpen = _ref.onErrorModalOpen,
    openRedirectModal = _ref.openRedirectModal;
  var _React$useContext = React.useContext(NewbuildingBrokerContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    brokerName = _React$useState2[0],
    setBrokerName = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    brokerUrl = _React$useState4[0],
    setBrokerUrl = _React$useState4[1];
  var fetchAndOpenBrokerLink = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var isRequestDelayed, resultPromise, timeoutPromise, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isRequestDelayed = false;
          openFetchingModal();
          resultPromise = fetchBrokerLinkData({
            newbuildingId: newbuildingId,
            newbuildingRegionId: newbuildingRegionId,
            houseId: houseId,
            httpApi: httpApi,
            logger: logger
          });
          timeoutPromise = new Promise(function (resolve) {
            setTimeout(function () {
              return resolve(FETCH_URL_TIMEOUT_RESULT);
            }, FETCH_URL_TIMEOUT);
          });
          _context.next = 6;
          return Promise.race([resultPromise, timeoutPromise]);
        case 6:
          result = _context.sent;
          if (!(result === FETCH_URL_TIMEOUT_RESULT)) {
            _context.next = 12;
            break;
          }
          isRequestDelayed = true;
          _context.next = 11;
          return resultPromise;
        case 11:
          result = _context.sent;
        case 12:
          closeFetchingModal();
          if (!('alreadyRegistered' in result && result.alreadyRegistered)) {
            _context.next = 17;
            break;
          }
          setBrokerName(result.brokerName);
          openAlreadyRegisteredModal();
          return _context.abrupt("return", result);
        case 17:
          if (!('brokerUrl' in result)) {
            _context.next = 24;
            break;
          }
          setBrokerUrl(result.brokerUrl);
          saveAgreementAccepted();
          if (isRequestDelayed) {
            openRedirectModal();
          } else {
            window.open(result.brokerUrl, '_blank', 'noopener');
          }
          return _context.abrupt("return", result);
        case 24:
          openErrorModal();
          if (onErrorModalOpen) {
            onErrorModalOpen();
          }
          return _context.abrupt("return", null);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [newbuildingId, newbuildingRegionId, houseId, openFetchingModal, closeFetchingModal, openErrorModal, openAlreadyRegisteredModal, openRedirectModal, onErrorModalOpen, httpApi, logger]);
  return {
    brokerName: brokerName,
    brokerUrl: brokerUrl,
    fetchAndOpenBrokerLink: fetchAndOpenBrokerLink
  };
};